import { defineComponent as _defineComponent } from 'vue';
import Vue, { computed } from "vue";
import BootstrapVue from "bootstrap-vue";
import { getZoomInLevel, getZoomOutLevel, isMinZoom, isMaxZoom } from "./modules/zoomLevels";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ZoomControl',
    props: {
        zoomLevel: { type: Number, default: 1 },
    },
    emits: ["onZoom"],
    setup(__props, { emit }) {
        const props = __props;
        Vue.use(BootstrapVue);
        const zoomDefault = 1;
        const zoomPercentage = computed(() => Math.round(props.zoomLevel * 100));
        function onZoomIn() {
            emit("onZoom", getZoomInLevel(props.zoomLevel));
        }
        function onZoomOut() {
            emit("onZoom", getZoomOutLevel(props.zoomLevel));
        }
        function onZoomReset() {
            emit("onZoom", zoomDefault);
        }
        return { __sfc: true, props, emit, zoomDefault, zoomPercentage, onZoomIn, onZoomOut, onZoomReset, isMinZoom, isMaxZoom };
    }
});
